export class Template {
  card_id: string | null;
  template_id: string;
  svg: string;
  name: string;
  selected: boolean;
  size: number;
  allow_local_price: boolean;
  enabled: boolean;
  require_local_price: false;
  require_store_price: false;
  allow_second_product: false;
  contents_equal_to_template: string;
  allow_multiple_cards: false;
  allow_free_text: false;
  allow_each_price: false;
  second_product_id: string;
//  TODO:
  id: string | undefined;
}



// WEBPACK FOOTER //
// /app/src/app/_models/template.ts